import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const quote = {
  fetchQuoteList: lazyModuleMethod(() => import('./fetchQuoteList'), 'default'),
  deleteQuote: lazyModuleMethod(() => import('./deleteQuote'), 'default'),
  createQuote: lazyModuleMethod(() => import('./createQuote'), 'default'),
  fetchQuote: lazyModuleMethod(() => import('./fetchQuote'), 'default'),
  updateQuote: lazyModuleMethod(() => import('./updateQuote'), 'default'),
  fetchQuoteArticles: lazyModuleMethod(
    () => import('./fetchQuoteArticles'),
    'default'
  ),
}
